module.exports = __webpack_public_path__ + "a6098ac9888f8f6a9728fde85ac4a23e.jpg";